import { render } from "./ProductCellImageSquare.vue?vue&type=template&id=62beffdc&scoped=true"
import script from "./ProductCellImageSquare.vue?vue&type=script&lang=js"
export * from "./ProductCellImageSquare.vue?vue&type=script&lang=js"

import "./ProductCellImageSquare.vue?vue&type=style&index=0&id=62beffdc&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62beffdc"]])

export default __exports__